// extracted by mini-css-extract-plugin
export var root = "popd";
export var rootAction = "QosW";
export var rootContainer = "M5w1";
export var rootLinks = "_1BPe";
export var rootMain = "Pe+Q";